module.exports = __webpack_public_path__ + "img/tf23-public.1c7f530a.png";